<script>
    import RecipeBlock from "./RecipeBlock.svelte";
    import {RecipesStore} from "./stores/RecipesStore";
    import RecipeCatPageHeader from "./RecipeCatPageHeader.svelte";
    import axios from "axios";

    export let firstSet;
    export let thisCategory;

    export let cuisines;
    export let cookingMethods;
    export let occasions;
    export let dietary;
    export let flavors;
    export let bakingType;

    let selectedDietary;
    let selectedTotalTime;
    let selectedFlavor;
    let selectedBakingType;
    let selectedOccasion;

    let selectedPrepTime;
    let selectedDifficulty;

    let totalPages = firstSet.totalPages;
    let totalCount = firstSet.total;
    let showingCount = firstSet.postCount


    RecipesStore.set(firstSet.data);

    function onSomethingSelected() {
        fetchResults();
    }

    function onClearButtonClicked() {
        selectedDietary = "";
        selectedTotalTime = "";
        selectedFlavor = "";
        selectedBakingType = "";
        selectedOccasion = "";
        selectedPrepTime = "";
        selectedDifficulty = "";
        fetchResults();
    }

    let noDataErrFlag = false;

    let currentPage = 1;

    function getSelectedCustomFields() {

        let obj = {};

        if(!hasOnlySpaces(selectedPrepTime)) {
            obj['prep_time'] = selectedPrepTime;
        }
        if(!hasOnlySpaces(selectedTotalTime)) {
            obj['ready_time'] = selectedTotalTime;
        }
        if(!hasOnlySpaces(selectedDifficulty)) {
            obj['difficulty'] = selectedDifficulty;
        }

        return obj;
    }

    function getSelectedCategories() {

        let cats = []

        cats = validateCategory(cats, selectedDietary, dietary);
        cats = validateCategory(cats, selectedFlavor, flavors);
        cats = validateCategory(cats, selectedBakingType, bakingType);
        cats = validateCategory(cats, selectedOccasion, occasions);

        return cats;
    }

    function hasOnlySpaces(string) {
        return /^\s*$/.test(string);

    }

    function validateCategory(result, selection, list) {
        if (!selection || hasOnlySpaces(selection)) return result;
        let cat = list.filter(value => value.term_id === Number(selection))[0];
        if (cat) result.push(cat);
        return result;
    }

    function OnLoadMoreClicked() {
        currentPage += 1;
        fetchResults(true);
    }

    let posts = []

    RecipesStore.subscribe(value => posts = value);

    async function fetchResults(loadMore = false) {

        let form_data = new FormData;

        let selCategories = JSON.stringify(getSelectedCategories());

        let selFields = JSON.stringify(getSelectedCustomFields());

        form_data.append('action', 'get_recipes_for_category')
        form_data.append('cats', selCategories)
        form_data.append('fields', selFields)
        form_data.append('current', Number(thisCategory.term_id))
        form_data.append('page', currentPage + '')


        await axios.post('/wp-admin/admin-ajax.php', form_data)
            .then((data) => {

                let arr = data.data.data;
                if (arr.length > 0) {
                    noDataErrFlag = false;
                    if (!loadMore) {
                        totalCount = data.data.total;
                        showingCount = data.data.postCount;
                        totalPages = data.data.totalPages;
                        RecipesStore.set(data.data.data);
                    } else {
                        RecipesStore.set(posts.concat(data.data.data))
                        totalCount = data.data.total;
                        showingCount += data.data.postCount
                    }

                } else {
                    totalPages = 0;
                    totalCount = 0;
                    showingCount = 0;
                    RecipesStore.set([]);
                    noDataErrFlag = true;
                }
            })
    }

</script>


<main data-role="main" role="presentation">
    <section id="recipe-search" class="page" data-acsb-main="true" role="main">
    
    <RecipeCatPageHeader/>
       
        <!--/#product-landing-banner-->

        <div class="content">

            <section class="filter-area">
                <div class="container">
                    <form action="" method="get" class="form-inline filter-form" data-acsb-form-uuid="aj2yhil8fq6"
                          data-acsb-form-type="standard">
                        <h2 class="filter-text" data-acsb-title="true">Filter:</h2> <br>
                        <div class="select-wrapper" data-acsb-overflower="true"
                             data-acsb-bg-image="https://pillsburybaking.com/pillsbury/static/images/select-wrapper-bg.png">
                            <span role="img" aria-label="Blue and white heart illustration" class="acsb-sr-only"
                                  data-acsb-sr-only="true" data-acsb-force-visible="true" aria-hidden="false"
                                  data-acsb-hidden="false"></span>
                            <select id="SpecialDietId" name="SpecialDietId" bind:value={selectedDietary}
                                    on:change="{onSomethingSelected}"
                                    data-val="true" class="form-control"
                                    aria-invalid="false" aria-required="false"
                                    aria-label="quantity" placeholder="quantity">
                                <option selected="selected" value="">-- Dietary --</option>
                                <option value="60">Zero Sugar</option>
                                <option value="61">Gluten Free</option>
                            </select>
                        </div>

                        <div class="select-wrapper" data-acsb-overflower="true"
                             data-acsb-bg-image="https://pillsburybaking.com/pillsbury/static/images/select-wrapper-bg.png">
                            <span role="img" aria-label="Blue and white heart illustration" class="acsb-sr-only"
                                  data-acsb-sr-only="true" data-acsb-force-visible="true" aria-hidden="false"
                                  data-acsb-hidden="false"></span>
                            <select id="ExperienceLevelId" bind:value={selectedDifficulty}
                                    name="ExperienceLevelId" data-val="true"
                                    class="form-control"
                                    on:change="{onSomethingSelected}"
                                    aria-invalid="false" aria-required="false"
                                    aria-label="quantity" placeholder="quantity">
                                <option selected="selected" value="">-- Difficulty --</option>
                                <option value="Easy">Easy</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Advanced">Advanced</option>
                            </select>
                        </div>

                        <div class="select-wrapper"
                             data-acsb-bg-image="https://pillsburybaking.com/pillsbury/static/images/select-wrapper-bg.png">
                            <span role="img" aria-label="Blue and white heart illustration" class="acsb-sr-only"
                                  data-acsb-sr-only="true" data-acsb-force-visible="true" aria-hidden="false"
                                  data-acsb-hidden="false"></span>
                            <select id="PreparationTime" name="PreparationTime" bind:value={selectedPrepTime}
                                    class="form-control"
                                    data-acsb-navigable="true"
                                    data-acsb-now-navigable="true"
                                    on:change="{onSomethingSelected}"
                                    aria-invalid="false"
                                     placeholder="quantity">
                                <option selected="selected" value="">-- Prep Time --</option>
                                <option value="1">20 minutes or less</option>
                                <option value="2">21-40 minutes</option>
                                <option value="3">41-60 minutes</option>
                                <option value="4">+60 minutes</option>
                            </select>
                        </div>


                        <div class="select-wrapper" data-acsb-overflower="true"
                             data-acsb-bg-image="https://pillsburybaking.com/pillsbury/static/images/select-wrapper-bg.png">
                            <span role="img" aria-label="Blue and white heart illustration" class="acsb-sr-only"
                                  data-acsb-sr-only="true" data-acsb-force-visible="true" aria-hidden="false"
                                  data-acsb-hidden="false"></span>
                            <select id="TotalTime" name="TotalTime" bind:value={selectedTotalTime}
                                    on:change="{onSomethingSelected}"
                                    class="form-control"
                                    aria-invalid="false" aria-required="false" placeholder="totalTime">
                                <option selected="selected" value="">-- Total Time --</option>
                                <option value="1">20 minutes or less</option>
                                <option value="2">21-40 minutes</option>
                                <option value="3">41-60 minutes</option>
                                <option value="4">+60 minutes</option>
                            </select>
                        </div>

                        <div class="select-wrapper" data-acsb-overflower="true"
                             data-acsb-bg-image="https://pillsburybaking.com/pillsbury/static/images/select-wrapper-bg.png">
                            <span role="img" aria-label="Blue and white heart illustration" class="acsb-sr-only"
                                  data-acsb-sr-only="true" data-acsb-force-visible="true" aria-hidden="false"
                                  data-acsb-hidden="false"></span>
                            <select id="Box_Mix_Vs_Scratch_Baking" bind:value={selectedBakingType}
                                    on:change="{onSomethingSelected}"
                                    name="Box_Mix_Vs_Scratch_Baking"
                                    class="form-control"
                                    aria-invalid="false" aria-required="false"
                                    aria-label="quantity" placeholder="quantity">
                                <option selected="selected" value="">-- Box Mix Vs Scratch Baking --</option>
                                <option value="132">Box Mix</option>
                                <option value="133">Scratch Baking</option>
                            </select>
                        </div>

                        <div class="select-wrapper" data-acsb-overflower="true"
                             data-acsb-bg-image="https://pillsburybaking.com/pillsbury/static/images/select-wrapper-bg.png">
                            <span role="img" aria-label="Blue and white heart illustration" class="acsb-sr-only"
                                  data-acsb-sr-only="true" data-acsb-force-visible="true" aria-hidden="false"
                                  data-acsb-hidden="false"></span>
                            <select id="OccasionId" name="OccasionId" bind:value={selectedOccasion}
                                    on:change="{onSomethingSelected}"
                                    data-val="true" class="form-control"
                                    type="select-one"
                                    data-acsb-field-visible="true"
                                    aria-invalid="false" aria-required="false"
                                    aria-label="quantity" placeholder="quantity"
                                    data-acsb-tooltip="quantity">
                                <option selected="selected" value="">-- Occasion --</option>
                                <option value="71">Funfetti Celebrations</option>
                                <option value="72">Valentine’s Day</option>
                                <option value="73">Easter</option>
                                <option value="74">Red, White &amp; Blue</option>
                                <option value="75">Summer</option>
                                <option value="76">Halloween</option>
                                <option value="77">Thanksgiving</option>
                                <option value="78">Christmas</option>
                                <option value="79">Party Snacks</option>
                                <option value="80">Birthdays</option>
                                <option value="81">Super Bowl Snacks</option>
                                <option value="82">Back to School</option>
                                <option value="83">More Holidays</option>
                            </select>
                        </div>

                        <div class="select-wrapper"
                             data-acsb-bg-image="https://pillsburybaking.com/pillsbury/static/images/select-wrapper-bg.png">
                            <span role="img" aria-label="Blue and white heart illustration" class="acsb-sr-only"
                                  data-acsb-sr-only="true" data-acsb-force-visible="true" aria-hidden="false"
                                  data-acsb-hidden="false"></span>
                            <select id="FlavorId" name="FlavorId" data-val="true" bind:value={selectedFlavor}
                                    on:change="{onSomethingSelected}"
                                    class="form-control"
                                    aria-invalid="false" aria-required="false"
                                    aria-label="quantity" placeholder="quantity">
                                <option selected="selected" value="">-- Flavor --</option>
                                <option value="62">Buttery</option>
                                <option value="63">Cinnamon</option>
                                <option value="64">Chocolate</option>
                                <option value="65">Coconut</option>
                                <option value="66">Fruity</option>
                                <option value="67">Nutty</option>
                                <option value="68">Pumpkin</option>
                                <option value="69">Spice</option>
                                <option value="70">Vanilla</option>
                            </select>
                        </div>

                        <input on:click={onClearButtonClicked} type="button" class="btn btn-primary btn-filter" value="Clear" data-acsb-clickable="true"
                               role="button"
                               aria-label="Clear">
                    </form>
                </div>
            </section>
            <div class="container">
                <p class="showing" id="showing">Showing
                    <strong><span>{showingCount}</span></strong> of
                    <strong><span>{totalCount}</span> Results</strong> for <strong id="test">{@html thisCategory.name}</strong></p>

                <section class="results recipe-grid">
                    {#each posts as post}
                        <RecipeBlock thumbnail={post.thumbnail} title={post.title} url={post.url}/>
                    {/each}

                </section>
                {#if noDataErrFlag || posts.length === 0}
                    <p>Uh-oh! We couldn’t find any recipes like that, but don’t give up.
                        Widen your search and try again.</p>
                {/if}
                {#if currentPage < totalPages}
                    <div class="load-more-section">
                        <div class="load-more-wrap">
                            <a class="btn btn-primary load-more" on:click={OnLoadMoreClicked}>Load More</a>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </section>
</main>
